export default {
  dark: "Tema Oscuro",
  light: "Tema Claro",
  metric: "Métrico",
  imperial: "Imperial",
  messages: {
    updateSuccess: "Su perfil fué actualizado exitosamente"
  },
  tabs: {
    basicInfo: "INFORMACIÓN BÁSICA",
    tasks: "TAREAS"
  },
  titles: {
    profile: "Perfil",
    tasks: "Mis Tareas"
  },
  labels: {
    maintenance: "Mantenimiento",
    repair: "Reparación",
    reliability: "Confiabilidad",
    recurrent: "Periódica",
    onetime: "Única",
    done: "Completada"
  },
  buttons: {
    gotoModules: "Módulos"
  }
};
